import { render, staticRenderFns } from "./NewMessageIcon.vue?vue&type=template&id=10caa84e&scoped=true"
import script from "./NewMessageIcon.vue?vue&type=script&lang=js"
export * from "./NewMessageIcon.vue?vue&type=script&lang=js"
import style0 from "./NewMessageIcon.vue?vue&type=style&index=0&id=10caa84e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10caa84e",
  null
  
)

export default component.exports